import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ErrorModal } from '../shared/ErrorModal';
import { Trophy, Ghost } from 'lucide-react';

export const AuthView = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, signup } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
      } else {
        if (!name) {
          setError('Please enter your name.');
          setLoading(false);
          return;
        }
        await signup(email, password, name);
      }
    } catch (err) {
      setError(err.message.replace('Firebase: ', ''));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
      <div className="max-w-md mx-auto w-full">
        <div className="text-center mb-6">
          <div className="bg-green-500/20 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 border-2 border-green-500">
            <Trophy className="w-10 h-10 text-green-400" />
          </div>
          <h1 className="text-3xl font-bold mb-2">Pool Match Tracker</h1>
          <p className="text-slate-400">{isLogin ? 'Log in to continue' : 'Create an account to save progress'}</p>
        </div>
        <div className="bg-slate-800/50 rounded-xl p-6 sm:p-8 space-y-4 border border-slate-700">
          <form onSubmit={handleSubmit} className="space-y-4">
            {!isLogin && (
              <div>
                <label className="block text-sm font-medium mb-2 text-slate-300">Name</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="w-full px-3 py-2.5 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-green-400" />
              </div>
            )}
            <div>
              <label className="block text-sm font-medium mb-2 text-slate-300">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full px-3 py-2.5 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-green-400" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 text-slate-300">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full px-3 py-2.5 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-green-400" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-all disabled:opacity-50 disabled:cursor-wait">
              {loading ? 'Processing...' : (isLogin ? 'Log In' : 'Sign Up')}
            </button>
          </form>
          <div className="text-center">
            <button onClick={() => setIsLogin(!isLogin)} className="text-sm text-green-400 hover:underline">
              {isLogin ? "Need an account? Sign Up" : "Already have an account? Log In"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};